import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import AllDataClass from "pages/common/AllDataClass";
import { useTranslation } from "react-i18next";

type ItemProp = {
  policyname: string;
  data: any;
  detailModalHandler: (n: any) => void;
  idx: any;
  catIdx: number;
  setMouseOver: React.Dispatch<React.SetStateAction<any>>;
};
const Policies = ({
  policyname,
  data,
  detailModalHandler,
  idx,
  catIdx,
  setMouseOver,
}: ItemProp) => {
  const { t } = useTranslation();
  const values = data[Object.keys(data)[0]];
  const onClickHander = () => {
    detailModalHandler(idx);
  };

  const onMouseOver = () => {
    AllDataClass.mouseOverPolicy = Object.keys(data)[0];
    setMouseOver(true);
  };
  const onMouseOut = () => {
    AllDataClass.mouseOverPolicy = "";
    setMouseOver(false);
  };
  return (
    <div
      className="policy"
      onClick={onClickHander}
      key={idx}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <div
        className="policy-selected"
        style={{
          visibility: AllDataClass?.selectedList?.includes(Object.keys(data)[0])
            ? "visible"
            : "hidden",
        }}
      />
      <div className="policy-name">
        {t("policy")} [{catIdx + 1}-{idx + 1}]
        <br />
        {values[2]?.split("\n")?.map((item: any, idx: any) => (
          <span key={idx}>
            {item}
            <br />
          </span>
        ))}
      </div>
      <div className="policy-category">{policyname}</div>
    </div>
  );
};

export default Policies;
